import { render } from "./AlloysContent.vue?vue&type=template&id=42708b35&ts=true"
import script from "./AlloysContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlloysContent.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/AlloysContent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "42708b35"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('42708b35', __exports__)) {
    api.reload('42708b35', __exports__)
  }
  
  module.hot.accept("./AlloysContent.vue?vue&type=template&id=42708b35&ts=true", () => {
    api.rerender('42708b35', render)
  })

}


export default __exports__